export const VERSION = '1.24.1';
